import { useEffect, useMemo, useRef, useState } from 'react';

/**
 * Bumps an epoch when the layout surface may have desynced (tab visibility, in-app view switch)
 * so TaskNode and HandlesLayer can resync.
 */
export function useFlowchartLayoutSurfaceEpoch({ activeView, currentView }) {
  const [layoutSurfaceEpoch, setLayoutSurfaceEpoch] = useState(0);

  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState === 'visible') {
        setLayoutSurfaceEpoch((n) => n + 1);
      }
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);

  const layoutSurfaceKey = useMemo(() => {
    if (activeView?.id != null && activeView?.viewMode != null) {
      return `av:${activeView.id}|${activeView.viewMode}`;
    }
    if (currentView != null && currentView !== '') {
      return `cv:${typeof currentView === 'string' ? currentView : String(currentView?.id ?? currentView)}`;
    }
    return 'default';
  }, [activeView?.id, activeView?.viewMode, currentView]);

  const prevLayoutSurfaceKeyRef = useRef(layoutSurfaceKey);
  useEffect(() => {
    if (prevLayoutSurfaceKeyRef.current === layoutSurfaceKey) return;
    prevLayoutSurfaceKeyRef.current = layoutSurfaceKey;
    setLayoutSurfaceEpoch((n) => n + 1);
  }, [layoutSurfaceKey]);

  return layoutSurfaceEpoch;
}
